import { inject, Injectable } from '@angular/core';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import moment, { Moment } from 'moment';

/**
 * L2-R7: moved from `src/app/shared/services/miq-date-adapter.service.ts`.
 *
 * REMOTE SCAFFOLD: every shell binds it with
 * `{ provide: DateAdapter, useClass: MiqDateAdapterService, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] }`,
 * so keeping it in `src/app/shared` forced both remotes to import host code for their own
 * bootstrap. It only overrides `today()` so that "today" is the local moment rather than the
 * UTC-shifted one MomentDateAdapter returns when `useUtc: true`.
 *
 * It lands in @miq/platform-ui rather than @miq/platform because it is Material-facing: it
 * subclasses `MomentDateAdapter` and injects `MAT_DATE_LOCALE`. @miq/platform declares no
 * @angular/material peer dependency and adding one would drag Material into every platform
 * consumer (including the admin remote's non-Material code paths).
 *
 * NOTE (unchanged from the host original): the `inject()` calls sit in the constructor's
 * `super(...)` arguments, not in field initializers, so this class is safe to import at module
 * scope — see the NG0203 note on `user-locale.service.ts`.
 */
@Injectable({
  providedIn: 'root',
})
export class MiqDateAdapterService extends MomentDateAdapter {
  constructor() {
    super(
      inject<string>(MAT_DATE_LOCALE, { optional: true }),
      inject(MAT_MOMENT_DATE_ADAPTER_OPTIONS)
    );
  }
  today(): Moment {
    return moment();
  }
}
